import { Filters } from "@shopify/polaris";
import React from "react";

import { reducerFn } from "../../helper";
import useTimeout from "../../hooks/useTimeout";
import { useChannelTeamCtx } from "./context";

export default function ChannelTeamFilter() {
  const [state, setState] = React.useReducer(reducerFn, {
    search: "",
  });

  const {filter, setFilter} = useChannelTeamCtx();

  const [setDelay] = useTimeout();
  const handleQueryChange = React.useCallback((search) => {
    setState({ search });

    setDelay(() => {
      setFilter({ search });
    });
  }, []);

  const handleQueryClear = React.useCallback(() => {
    setState({ search: "" });

    setDelay(() => {
      setFilter({ search: "" });
    });
  }, []);

  const handleClearAll = React.useCallback(() => {
    handleQueryClear();
  }, []);

  const filters = [];
  return (
    <Filters
      filters={filters}
      appliedFilters={[]}
      queryPlaceholder="Search Channel Team"
      queryValue={state.search}
      onClearAll={handleClearAll}
      onQueryChange={handleQueryChange}
      onQueryClear={handleQueryClear}
    />
  );
}
